import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

const ClockIcon = () => (
  <svg className="w-5 h-5 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

const MonthlyHistoryTable = ({ history, formatAmount, onMonthClick, onDeleteMonth }) => {
  const navigate = useNavigate();
  const handleClick = (month) => {
    if (onMonthClick) {
      onMonthClick(month);
    } else {
      navigate(`/month/${month.id}`);
    }
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200/50 dark:border-gray-700/50 overflow-hidden">
      <div className="flex items-center gap-2 p-6 border-b border-gray-200 dark:border-gray-700">
        <ClockIcon />
        <h3 className="text-lg font-bold text-gray-900 dark:text-white">Historial de Meses</h3>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-50 dark:bg-gray-900/50">
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wider">
                Mes
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wider">
                Ingresos
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wider">
                Gastos
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wider">
                Ahorro
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wider">
                Balance
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wider">
                Pendientes
              </th>
              {onDeleteMonth && (
                <th className="px-6 py-4 text-right text-xs font-semibold text-gray-600 dark:text-gray-400 w-16" />
              )}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
            {history.map((month) => (
              <tr
                key={month.id}
                className="hover:bg-gray-50 dark:hover:bg-gray-700/50 cursor-pointer transition-colors"
                onClick={() => handleClick(month)}
              >
                <td className="px-6 py-4">
                  <span className="font-medium text-blue-600 dark:text-blue-400 hover:underline">
                    {month.name}
                  </span>
                </td>
                <td className="px-6 py-4 text-green-600 dark:text-green-400 font-medium">
                  {formatAmount(month.ingresos)}
                </td>
                <td className="px-6 py-4 text-red-600 dark:text-red-400 font-medium">
                  {formatAmount(month.gastos)}
                </td>
                <td className="px-6 py-4 text-orange-600 dark:text-orange-400 font-medium">
                  {formatAmount(month.ahorro)}
                </td>
                <td className="px-6 py-4 text-blue-600 dark:text-blue-400 font-medium">
                  {formatAmount(month.restante)}
                </td>
                <td className="px-6 py-4 text-gray-900 dark:text-white">
                  {month.pendientes}
                </td>
                {onDeleteMonth && (
                  <td className="px-6 py-4 text-right">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onDeleteMonth(e, month);
                      }}
                      className="p-2 text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors"
                      aria-label={`Eliminar ${month.name}`}
                      title="Eliminar mes"
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        />
                      </svg>
                    </button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

MonthlyHistoryTable.propTypes = {
  history: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      ingresos: PropTypes.number.isRequired,
      gastos: PropTypes.number.isRequired,
      ahorro: PropTypes.number.isRequired,
      restante: PropTypes.number.isRequired,
      pendientes: PropTypes.number.isRequired
    })
  ).isRequired,
  formatAmount: PropTypes.func.isRequired,
  onMonthClick: PropTypes.func,
  onDeleteMonth: PropTypes.func
};

export { MonthlyHistoryTable };
